import React from "react";
import { Box } from '@curves/ui-base';
import { MeasurementClickableCard, AnalysisResultBox } from "../Common";
import AccessibilityNewIcon from "@mui/icons-material/AccessibilityNew";
import ScatterPlotIcon from "@mui/icons-material/ScatterPlot";

const BodyAnalysisSection = ({ sourceData, onTrendLineClick }) => {
	return (
		<>
			<Box className="measurement-group-content--2">
				<MeasurementClickableCard
					className="measurement-group-content__item"
					name="體質量指數 (BMI)"
					value={sourceData?.bmi}
					unit="kg/m²"
					icon={<AccessibilityNewIcon />}
					onClick={() => onTrendLineClick(sourceData?.bmiTrendType)}
				/>
				<MeasurementClickableCard
					className="measurement-group-content__item"
					name="體脂率 (PBF)"
					value={sourceData?.pbf}
					unit="%"
					icon={<ScatterPlotIcon />}
					onClick={() => onTrendLineClick(sourceData?.pbfTrendType)}
				/>
			</Box>
			<Box className="px-1">
				<AnalysisResultBox className="measurement-group-content__item" Tip={sourceData?.bmiCategoryTip} Desc={sourceData?.bmiCategoryDesc} />
			</Box>
		</>
	);
};

export default BodyAnalysisSection;
